var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4401_32234)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.293 0.292893C14.6835 -0.0976311 15.3167 -0.0976311 15.7072 0.292893L19.6365 4.22218C20.0661 4.65176 20.0661 5.34824 19.6365 5.77782L15.7072 9.70711C15.3167 10.0976 14.6835 10.0976 14.293 9.70711C13.9025 9.31658 13.9025 8.68342 14.293 8.29289L16.5859 6H9.00008C8.4478 6 8.00008 5.55228 8.00008 5C8.00008 4.44772 8.4478 4 9.00008 4H16.5859L14.293 1.70711C13.9025 1.31658 13.9025 0.683417 14.293 0.292893ZM10.8985 14C11.4508 14 11.8985 14.4477 11.8985 15C11.8985 15.5523 11.4508 16 10.8985 16H3.4143L5.70719 18.2929C6.09771 18.6834 6.09771 19.3166 5.70719 19.7071C5.31667 20.0976 4.6835 20.0976 4.29298 19.7071L0.363687 15.7778C-0.0658867 15.3482 -0.0658939 14.6518 0.363686 14.2222L4.29298 10.2929C4.6835 9.90237 5.31667 9.90237 5.70719 10.2929C6.09771 10.6834 6.09771 11.3166 5.70719 11.7071L3.4143 14H10.8985Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4401_32234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.c79de3211683a608cb8262e94490cc06.svg";
export { ForwardRef as ReactComponent };